import { createBrowserClient } from '@supabase/ssr';

// createBrowserClient stores the session in cookies (not localStorage),
// making it readable by the server-side middleware for SSR/route protection.
export const supabase = createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!
);

// On every page load, GoTrueClient's own init (_recoverAndRefresh) tries to refresh
// whatever session cookie is stored, and unconditionally console.error()s if that
// fails — even for a stale/already-invalidated refresh token left over from a
// previous session. That case is expected and already handled correctly: the SDK
// removes the dead cookie and fires SIGNED_OUT, which authStore's listener reacts to
// via syncSignedOut(). This is unchanged upstream (github.com/supabase/auth-js), so
// filter just this one known-benign, already-handled error out of the console —
// every other console.error (including other auth errors) still passes through.
if (typeof window !== 'undefined') {
    const nativeConsoleError = console.error;
    console.error = (...args: unknown[]) => {
        const [first] = args;
        if (
            first instanceof Error &&
            first.name === 'AuthApiError' &&
            (first as { code?: string }).code === 'refresh_token_not_found'
        ) {
            return;
        }
        nativeConsoleError(...args);
    };
}
